import React from 'react';
import { Tr as TrStyled } from './styles';
import { ITable } from '../../interfaces/Table.interface';

const Tr: React.FC = ({ children, cursor }: ITable) => <TrStyled cursor={cursor}>{children}</TrStyled>;

export default Tr;
